import loginReducer from './login/loginReducer';
import navigationReducer from './navigation/navigationReducer';
import ledgerReducer from './ledger/ledgerReducer';
import purchaseReducer from './purchase/purchaseReducer';
import sellReducer from './sell/sellReducer';

export default {
  login: loginReducer,
  navigation: navigationReducer,
  ledger: ledgerReducer,
  purchase: purchaseReducer,
  sell: sellReducer
};
